import t from "react";
const o = t.createContext(null);
export {
  o as PaymentMethodCtx
};
//# sourceMappingURL=paymentMethodContext.js.map
